import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class Check  {
    _originalTypeClassName = "zERP.BO.Check";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
Check.translate = translateService;
}
this.Entity = new Domain.BusinessEntity();
this.Checkbook = new Domain.Checkbook();
this.Status = new Domain.CheckStatus();
this.Id = null;
this.TotalAmount = null;
this.IsPayed = false;
this.DatePayed = null;
this.CheckNumber = null;
this.Comments = null;
this.DateCreated = null;
this.Type = null;
this.DateToExpire = null;
this.IsPrinted = false;
this.Transferable = false;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
TotalAmount:any;
IsPayed:any;
DatePayed:any;
CheckNumber:any;
Comments:any;
DateCreated:any;
Type:any;
DateToExpire:any;
IsPrinted:any;
Transferable:any;
BankAccount:any;
Beneficiary:any;
Entity:any;
Currency:any;
Checkbook:any;
Status:any;
ChecksList:any;
Payment:any;
MoneyTransaction:any;
static setBankAccount = ($this, value) => {
var oldValue = $this.BankAccount;
$this.BankAccount = value;
if (value != null) {
}
}
static setBeneficiary = ($this, value) => {
var oldValue = $this.Beneficiary;
$this.Beneficiary = value;
if (value != null) {
}
}
static setEntity = ($this, value) => {
var oldValue = $this.Entity;
$this.Entity = value;
if (value != null) {
}
}
static setCurrency = ($this, value) => {
var oldValue = $this.Currency;
$this.Currency = value;
if (value != null) {
}
}
static setCheckbook = ($this, value) => {
var oldValue = $this.Checkbook;
$this.Checkbook = value;
if (value != null) {
if (oldValue != null) {
Domain.Checkbook.removeChecks(oldValue, $this);
}
Domain.Checkbook.addChecks(value, $this);
}
}
static setStatus = ($this, value) => {
var oldValue = $this.Status;
$this.Status = value;
if (value != null) {
}
}
static setChecksList = ($this, value) => {
var oldValue = $this.ChecksList;
$this.ChecksList = value;
if (value != null) {
if (oldValue != null) {
Domain.ChecksList.removeChecks(oldValue, $this);
}
Domain.ChecksList.addChecks(value, $this);
}
}
static setPayment = ($this, value) => {
var oldValue = $this.Payment;
$this.Payment = value;
if (value != null) {
if (oldValue != null && oldValue.Check != null) { oldValue.Check = null; }
if ($this.Payment.Check !== $this) {
Domain.PaymentLine.setCheck(value, $this);
}
}
}
static setMoneyTransaction = ($this, value) => {
var oldValue = $this.MoneyTransaction;
$this.MoneyTransaction = value;
if (value != null) {
if (oldValue != null && oldValue.Check != null) { oldValue.Check = null; }
if ($this.MoneyTransaction.Check !== $this) {
Domain.MoneyTransaction.setCheck(value, $this);
}
}
}

static GetClassName(): any{return "Check";
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}